import { createIcon } from './createIcon'

export const BarChartIcon = createIcon({
  displayName: 'BarChartIcon',
  viewBox: '4.6665 4.66663 10.6667 10.66667',
  path: [
    <path
      d="M12.6665 15.3333V10.6666H15.3332V15.3333H12.6665ZM8.6665 15.3333V4.66663H11.3332V15.3333H8.6665ZM4.6665 15.3333V7.99996H7.33317V15.3333H4.6665Z"
      fill="currentColor"
    />,
  ],
})
